<template>
  <div class="cardlist">
    <div class="cardlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px;"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning" plain class="el-icon-plus"
            @click="dialogFormVisible = true"
          >新增</el-button>
          <el-button type="info" icon="el-icon-upload" plain @click="intoList">导入</el-button>
          <el-button type="info" icon="el-icon-document" plain @click="downLoad">表格模板下载</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
        >
          <el-table-column label="设备编号" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备描述"
            style="width: 20%"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="门禁读卡器编号"
            style="width: 20%"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.rfidReaderVoList.length>0">
                <div
                  v-for="(item,index) in scope.row.rfidReaderVoList"
                  :key="index"
                >{{item.rfidReaderNo}}</div>
              </div>
              <div style="margin-left: 10px;color:orange;" v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="绑定位置" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.rfidReaderVoList.length>0">
                <div
                  v-for="(item,index) in scope.row.rfidReaderVoList"
                  :key="index"
                >{{item.location}}</div>
              </div>
              <div style="margin-left: 10px;color:orange;" v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="权限开关" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.rfidReaderVoList.length>0">
                <div v-for="(item,index) in scope.row.rfidReaderVoList" :key="index">
                  <span style="margin-left: 10px;color:green;" v-if="item.permission==1">开</span>
                  <span style="margin-left: 10px;color:red;" v-else>关</span>
                </div>
              </div>
              <div style="margin-left: 10px;color:orange;" v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button>
              <el-button
                 type="danger"
                size="mini"
                plain
                @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button>
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.status"
               plain
                @click="handleBangdi(scope.$index, scope.row)"
              >绑定</el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="!scope.row.status"
               plain
                @click="handleJiebang(scope.$index, scope.row)"
              >解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="cardxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="cardedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="“请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出绑定门禁控制卡-->
      <el-dialog
        title="绑定门禁控制卡"
        :visible.sync="dialogFormBangdi"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="bangdilocation"
        @close="closeBangdi"
        width="900px;"
      >
        <el-form ref="formBangdi" :model="formBangdi" :rules="formBangdiRules">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="门禁控制卡设备编号 :"
                :label-width="formLabelWidthTwo"
                prop="bindDeviceNo"
              >
                <span style="height:40px;line-height:40px;">{{ formBangdi.bindDeviceNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="门禁控制卡设备名称 :"
                :label-width="formLabelWidthTwo"
                prop="bindDeviceName"
              >
                <span style="height:40px;line-height:40px;">{{ formBangdi.bindDeviceName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="门禁读卡器一设备 :"
                :label-width="formLabelWidthTwo"
                prop="accessCardNoOne"
              >
                <el-select
                  v-model="formBangdi.accessCardNoOne"
                  placeholder="请选择门禁读卡器"
                  filterable
                  @change="handleChangeAccessCardNoOne"
                >
                  <el-option
                    v-for="(item,index) in accessCardList"
                    :key="index"
                    :label="item.deviceNo"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="门禁读卡器二设备 :"
                :label-width="formLabelWidthTwo"
                prop="accessCardNoTwo"
              >
                <el-select
                  v-model="formBangdi.accessCardNoTwo"
                  placeholder="请选择门禁读卡器"
                  filterable
                  @change="handleChangeAccessCardNoTwo"
                >
                  <el-option
                    v-for="(item,index) in accessCardList"
                    :key="index"
                    :label="item.deviceNo"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="门禁读卡器一位置 :"
                :label-width="formLabelWidthTwo"
                prop="accessCardLocationOne"
              >
                <el-input
                  v-model.trim="formBangdi.accessCardLocationOne"
                  :readonly="true"
                  auto-complete="off"
                  style="width:220px;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="门禁读卡器二位置 :"
                :label-width="formLabelWidthTwo"
                prop="accessCardLocationTwo"
              >
                <el-input
                  v-model.trim="formBangdi.accessCardLocationTwo"
                  :readonly="true"
                  auto-complete="off"
                  style="width:220px;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="权限开关一 :" :label-width="formLabelWidthTwo" prop="switchOne">
                <el-radio-group
                  v-model="formBangdi.switchOne"
                  style="width:220px;height:45px;line-height:48px;"
                >
                  <el-radio :label="1">开</el-radio>
                  <el-radio :label="0">关</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="权限开关二 :" :label-width="formLabelWidthTwo" prop="switchTwo">
                <el-radio-group
                  v-model="formBangdi.switchTwo"
                  style="width:220px;hieght:45px;line-height:48px;"
                >
                  <el-radio :label="1">开</el-radio>
                  <el-radio :label="0">关</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelBangdi">取 消</el-button>
          <el-button type="primary" @click="submitFormBangdi('formBangdi')">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 表格导入的dialog -->
      <el-dialog
        title="设备导入"
        width="30%"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="closeDialogReset"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      location: "", //绑定门禁读卡器位置
      formInline: {
        inputdeviceno: ""
      },

      //绑定门禁组
      dialogFormBangdi: false,
      formBangdi: {
        bindDeviceNo: "", //绑定模态框弹出的设备编号
        bindDeviceName: "", //绑定模态框弹出的设备名称
        accessGroupName: "", //门禁组的名称
        accessCardNoOne: "", //门禁读卡器一
        accessCardNoTwo: "", //门禁读卡器二
        accessCardLocationOne: "", //门禁读卡器位置一
        accessCardLocationTwo: "", //门禁读卡器位置二
        switchOne: 1, //权限开关一 默认是开---1
        switchTwo: 1, //权限开关二 默认是开---1
        rfidReaderOneId: "", //门禁读卡器一的id
        rfidReaderTwoId: "", //门禁读卡器二的id
        numberOne: 0, //门禁读卡器一的位置序号
        numberTwo: 1 //门禁读卡器二的位置序号
      },

      accessCardList: [], //门禁读卡器的list  模态框中两个下拉菜单的数据源
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: ""
      },
      formLabelWidth: "100px",
      formLabelWidthTwo: "180px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: ""
      },

      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 1, max: 16, message: "长度在 1到 16 个字符" },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          // {
          //   pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi,
          //   message: "请输入由数字,大小写字母和_或-组成的字符"
          // }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 1, max: 16, message: "长度在 1到 16 个字符" },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          // {
          //   pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi,
          //   message: "请输入由数字,大小写字母和_或-组成的字符"
          // }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ]
      },
      formBangdiRules: {
        bindDeviceNo: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        bindDeviceName: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        accessCardNoOne: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change" //何事件触发
          }
        ],
        accessCardNoTwo: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change" //何事件触发
          }
        ],
        accessCardLocationOne: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        accessCardLocationTwo: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        switchOne: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change" //何事件触发
          }
        ],
        switchTwo: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change" //何事件触发
          }
        ]
      },
      fileFlag:false,
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },

    //关闭绑定dialog的回调
    closeBangdi() {
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //绑定 取消的dialog
    cancelBangdi() {
      this.dialogFormBangdi = false;
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //解绑
    handleJiebang(index, row) {
      console.log(index, row);
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          let id = row.id;
          this.$postJson("dmc/controllerCard/untied/" + id).then(res => {
            console.log(res);
            this.getTableData();
            if (res.code != "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }, 300);
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
            }
          });
        })
        .catch(() => {});
    },

    //门禁读卡器一下拉框
    handleChangeAccessCardNoOne(val) {
      console.log(val);
      this.accessCardList.forEach(item => {
        if (val == item.id) {
          this.formBangdi.accessCardLocationOne = item.location;
          this.formBangdi.rfidReaderOneId = item.id;
        }
      });
    },

    //门禁读卡器二下拉框
    handleChangeAccessCardNoTwo(val) {
      console.log(val);
      this.accessCardList.forEach(item => {
        if (val == item.id) {
          this.formBangdi.accessCardLocationTwo = item.location;
          this.formBangdi.rfidReaderTwoId = item.id;
        }
      });
    },

    //绑定门禁读卡器 弹出模态框
    handleBangdi(index, row) {
      console.log(index, row);
      this.dialogFormBangdi = true;
      this.queryNotBindRfidReader(); //获取未绑定的门机读卡器
      // this.formBangdi = Object.assign({}, row); //拷贝数据
      this.formBangdi.deviceId = row.id;
      this.formBangdi.bindDeviceNo = row.deviceNo;
      this.formBangdi.bindDeviceName = row.deviceName;
      console.log(this.formBangdi);
    },

    //绑定门禁读卡器提交数据
    submitFormBangdi(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          //需要判断两个门禁读卡器不能同时选择同一个
          if (
            this.formBangdi.rfidReaderOneId != this.formBangdi.rfidReaderTwoId
          ) {
            let param = new Object();
            let rfidReaderBindDtoList = new Array();
            let accessOneObj = new Object();
            let accessTwoObj = new Object();
            accessOneObj.rfidReaderId = this.formBangdi.rfidReaderOneId; //门禁读卡器一的id
            accessOneObj.number = 0; //门禁读卡器一的位置    0就是门禁读卡器一的位置序号
            accessOneObj.permission = this.formBangdi.switchOne; //门禁读卡器一的权限开关  0---关   1---开
            accessTwoObj.rfidReaderId = this.formBangdi.rfidReaderTwoId; //门禁读卡器二的id
            accessTwoObj.number = 1; //门禁读卡器二的位置   1就是门禁读卡器二的位置序号
            accessTwoObj.permission = this.formBangdi.switchTwo; //门禁读卡器二的权限开关   0---关   1---关
            rfidReaderBindDtoList.push(accessOneObj, accessTwoObj);
            console.log(rfidReaderBindDtoList, "rfidReaderBindDtoList");
            param.controllerCardId = this.formBangdi.deviceId; //门禁控制卡id
            param.rfidReaderBindDtoList = rfidReaderBindDtoList; //门禁读卡器集合
            console.log(param);
            this.$postJson("dmc/controllerCard/bind", param).then(res => {
              console.log(res);
              this.dialogFormBangdi = false;
              if (res.code == "10061008") {
                setTimeout(() => {
                  this.$message({
                    message: "门禁卡读卡器已经绑定过",
                    type: "error"
                  });
                }, 300);
              } else {
                this.getTableData();
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
              }
            });
          } else {
            this.$message({
              message: "门禁读卡器一和门禁读卡器二不能同时选择同一个",
              type: "error"
            });
          }
        }
      });
    },

    //点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/controllerCard/edit", param)
            .then(res => {
              console.log(res);
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
                console.log("修改成功!");
              }
              //console.log(this.$store.state.count)
            })
            .catch(res => {
              this.$message({
                type: "error",
                message: res.message
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
             this.$postJson(`dmc/propertyManagement/untie`,{deviceIds:[id]}).then(res => { // 旧 dmc/controllerCard/deleteById/
             if(res.code ==200){
                this.getTableData();
              console.log(res);
              this.$message({
                type: "success",
                message: res.message
              });
             }else{
                this.$message({
                type: "error",
                message: res.message
              });
             }
             
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!"
        });
      }
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/propertyManagement/bindDeviceMerchant", param) //旧： dmc/controllerCard/add
            .then(res => {
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
           
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },
    //查询表格的数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        location: ""
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/controllerCard/queryListWithPage", param).then(
        res => {
          console.log(res);
          //判断是否有数据
          if (res.result!=null && res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            console.log(this.list);
            res.result.list.forEach((item, index) => {
              console.log(item);
              if (item.bind == true) {
                this.$set(item, "status", false);
              } else if (item.bind == false) {
                this.$set(item, "status", true);
              }
            });
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },

    //查询未绑定的门禁读卡器
    queryNotBindRfidReader() {
      this.accessCardList = []; //请求之前先将数据清空，防止累计
      this.$postForm("dmc/controllerCard/queryNotBindRfidReader").then(res => {
        console.log(res);
        if (res.code == 200) {
          this.accessCardList = res.result;
        } else {
          this.accessCardList = [];
        }
        console.log(this.accessCardList);
      });
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag=true;//by guo 2020-8-4-14:52添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if(this.fileFlag){
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then(res => {
          this.dialogVisible = false;
          this.formData={};
          this.fileFlag=false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }else{
        this.$message({message:'请选择文件',type:'error'})
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },

  // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    tableData(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    data: "onSubmit", //值可以为methods的方法
    operates: {
      handler: function(newVal, oldVal) {
        console.log(newVal, oldVal);
        this.operates = newVal;
      },
      deep: true
    },
    formedit: {
      handler: function(newVal, oldVal) {
        console.log(newVal, oldVal);
        this.formedit = newVal;
      },
      deep: true
    }
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },
  mounted() {},
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.cardlist {
  .cardlist-m {
    padding: 10px 0 0 5px;
  }
}
//修改element-ui默认的样式
.del {
  color: red !important;
}
.exitrecord {
  color: green !important;
  margin-right: 10px;
}
.fenye {
  padding: 30px 0;
  background: #fff;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .cardxz .el-dialog {
    width: 30% !important;
  }
}
//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .cardedit .el-dialog {
    width: 30% !important;
  }
}
//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::deep .bangdilocation .el-dialog {
    width: 60% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::deep .bangdilocation .el-dialog {
    width: 75% !important;
  }
}
</style>


